import $ from "jquery"
import _ from "underscore"
import TaskManagementStore from "../TaskManagementStore"
import PageOverlayTipsManager from "../../tips/PageOverlayTipsManager"
import {connect} from "../../redux/utils"
import {bindActionCreators} from 'redux'
import {getArchivedProjectIds, getShownColumnsWithOrder, getTasksSorting} from "./selectors"
import {changeTasksSortingAction, updateTaskTypeOfWork} from "./actions"
import {
    getEditableProjectIds,
    getManageableTaskIds,
    getSingleCPSelection,
    getViewerSettings,
    isBulkOperationsPanelShown,
    isCPPanelClosed,
    isNeedToShowSelection
} from "../common/selectors"
import TaskTableHeader from './TaskTableHeader'
import TaskRowsTableContent from './TaskRowsTableContent'
import TemplateView from '../../TemplateView'
import AutoScrollableWrapper from '../kanban/components/AutoScrollableWrapper'
import {TaskSortBy} from '../constants'
import {isMSIE} from '../../atBrowserUtils'
import {getSelectedTaskIds} from '../taskSelection/selectors'
import TasksNotFoundMessage from '../components/TasksNotFoundMessage'
import {showSupportQuestionButton} from '../../support/supportForm/selectors'

export class TasksTable extends TemplateView {
    constructor({
        changeTasksSortingAction = () => {},
        updateTaskTypeOfWork = () => {},
    }) {
        super()
        this.updateOnInit = true

        this.actions = {
            changeTasksSortingAction,
            updateTaskTypeOfWork,
        }

        this.state = {
            sorting: {
                by: '',
                asc: false,
            },

            archivedProjectIds: {},
            viewerSettings: {
                hasEditHierarchyRight: false,
                hasAccessToAllManagementScope: false,
                canAccessCompleteTaskInformation: false
            },
            manageableTaskIds: {},
            editableProjectIds: {},
            showSelection: false,
            singleCPSelection: {},
            selectedTaskIds: {},
            bulkOperationsPanelShown: false,
            columnsWithOrder: [],
            isCPPanelClosed: false,
            scrollToTopButtonShifted: false,
        }

        this.onAnyStatePropertyChanged(['viewerSettings', 'manageableTaskIds', 'showSelection', 'editableProjectIds'], () => {
            this._updateTaskSelectionView()
        })

        this.onStatePropertyChanged('selectedTaskIds', () => {
            this._updateTaskSelectionView()
        })

        this.onStatePropertyChanged('scrollToTopButtonShifted', (scrollToTopButtonShifted) => {
            this.getEl().toggleClass('scrollToTopButtonShifted', scrollToTopButtonShifted)
        })
    }

    templateHtml() {
        return "<div class='tasksTable'></div>"
    }

    afterRender() {
        this.header = new TaskTableHeader()

        this.taskRowsTableContent = new TaskRowsTableContent({
            afterWidthChanged: () => this.taskTableContentHorizontalScrollWrapper.refreshScroll(),
        })

        this.registerChildComponents(this.taskRowsTableContent)

        this.taskTableContentVerticalScrollWrapper = new AutoScrollableWrapper({
            components: [this.taskRowsTableContent],
            additionalClasses: 'tasksTableVerticalScrollContainer',
            autoScrollEnabled: false,
            enableVerticalScroll: true,
            verticalScrollConfig: {
                probeType: 2
            },
            verticalScrollContainerClass: 'tasksTable',
            showScrollToTopButton: true,
            scrollToTopButtonAdditionalClass: 'tasksTableVerticalScrollToTopButton',
            onVerticalScrollCb: this._onScrollCb,
            onScrollToBottom: () => {
                if (!this.suppressScrollCheck) {
                    $(document).trigger("taskManagement_tasksTable_scrollToEnd")
                    this.suppressScrollCheck = true
                }
            }
        })

        const tasksTableHorizontalScrollableWrapper = 'tasksTableHorizontalScrollableWrapper'
        this.taskTableContentHorizontalScrollWrapper = new AutoScrollableWrapper({
            components: [this.header, this.taskTableContentVerticalScrollWrapper],
            additionalClasses: tasksTableHorizontalScrollableWrapper,
            autoScrollEnabled: false,
            enableHorizontalScroll: true,
            horizontalScrollConfig: {
                probeType: 2,
                mouseWheel: false
            },
            onHorizontalScrollCb: this._onScrollCb,
        })

        this.taskTableContentHorizontalScrollWrapper.init(this.getEl())

        this.tasksNotFoundMessage = new TasksNotFoundMessage().init(this.find(`.${tasksTableHorizontalScrollableWrapper}`))

        this.$el.toggleClass("incompleteTaskInformation", !this.state.viewerSettings.canAccessCompleteTaskInformation)

        $(TaskManagementStore).on("taskIdsReplace", () => {
            this._clearTaskRows()
            _.each(TaskManagementStore.getCreatedTaskIds(), (taskId) => {
                this.taskRowsTableContent.addNewCreatedTaskRow(taskId)
            })
            this._appendTaskRows()
            this._updateCpSelectionClasses()
        })

        $(TaskManagementStore).on("taskIdsAppend", () => this._appendTaskRows())
        $(TaskManagementStore).on("createdTaskIdsAppend", (e, taskIds) => this._appendCreatedTaskRows(taskIds))

        // TODO bakharev: convert to callback
        $(document).on("taskManagement_tasksTable_taskRow_typeOfWorkChange", (e, {taskId, typeOfWorkId}) => {
            this.actions.updateTaskTypeOfWork(taskId, typeOfWorkId)
        })

        $(document).on("taskManagement_removeTasks", (e, taskIds) => {
            if (_.isUndefined(taskIds))
                return

            this.taskRowsTableContent.removeRows(taskIds)

            this._updateNoTasksMessage(this.taskRowsTableContent.isTaskRowsEmpty())

            this.taskTableContentVerticalScrollWrapper.refreshScroll()
            PageOverlayTipsManager.getInstance().refreshDynamicTips()
        })

        this.taskRowsTableContent.showReloadLoadingMoire()

        if (isMSIE()) {
            this.onAnyStatePropertyChanged(['isCPPanelClosed', 'columnsWithOrder'], _.debounce(() => this._setWidthsForIE(), 500))
            $(window).resize(_.debounce(() => this._setWidthsForIE(), 500))
        }
    }

    _setWidthsForIE() {
        let fixWidthColumnsWidth = 165 // status column  width

        const columnsWithOrder = this.state.columnsWithOrder
        if (this.state.showSelection) fixWidthColumnsWidth += 40
        if (columnsWithOrder.includes(TaskSortBy.TYPE_OF_WORK)) fixWidthColumnsWidth += 165
        if (columnsWithOrder.includes(TaskSortBy.ESTIMATE)) fixWidthColumnsWidth += 100
        if (columnsWithOrder.includes(TaskSortBy.SPENT_TIME)) fixWidthColumnsWidth += 100
        if (columnsWithOrder.includes(TaskSortBy.DEADLINE)) fixWidthColumnsWidth += 185
        if (columnsWithOrder.includes(TaskSortBy.LAST_TRACKING_DATE)) fixWidthColumnsWidth += 160
        if (columnsWithOrder.includes(TaskSortBy.CREATION_DATE)) fixWidthColumnsWidth += 140
        fixWidthColumnsWidth += 40 // config column

        const tableComponentWidth = this.find('.tasksTableHorizontalScrollableWrapper').width()
        let namesColumnWidth = 275
        const remainder = tableComponentWidth - fixWidthColumnsWidth
        if (remainder > namesColumnWidth) namesColumnWidth = remainder
        const innerScrollableContainerWidth = fixWidthColumnsWidth + namesColumnWidth

        const $names = this.find('.names')
        $names.css({"flex": "auto"})
        $names.width(namesColumnWidth)
        const $innerScrollableContainer = this.find('.innerScrollableContainer')
        $innerScrollableContainer.css({"min-width": innerScrollableContainerWidth + "px"})

        this.taskTableContentHorizontalScrollWrapper.refreshScroll()
    }

    _onScrollCb = (scrollPosition) => {
        this.header.setState({isScrolling: scrollPosition !== 0})
    }

    _updateTaskSelectionView() {
        let selectedTaskIds = this.state.selectedTaskIds
        this.taskRowsTableContent.clearTasksSelection()
        this._updateTaskRowsSelection(selectedTaskIds)
    }

    _updateTaskRowsSelection(selectedTaskIds) {
        if (this.state.showSelection) this.taskRowsTableContent.setTasksSelected(selectedTaskIds)
    }

    _clearTaskRows() {
        this.taskRowsTableContent.clearRows()
    }

    _appendTaskRows() {
        let taskIds = TaskManagementStore.getTaskIds()
        this.taskRowsTableContent.appendTaskRows(taskIds, true)
        this.taskRowsTableContent.hideLoadingMoires()
        this.suppressScrollCheck = false
        this._updateView(taskIds.length)
    }

    _appendCreatedTaskRows(createdTaskIds) {
        this.taskRowsTableContent.appendCreatedTaskRows(createdTaskIds, true)
        this._updateView(createdTaskIds.length)
    }

    _updateCpSelectionClasses() {
        this.$el.toggleClass("hasSelectedCustomer", !!this.state.singleCPSelection.customerId)
        this.$el.toggleClass("hasSelectedProject", !!this.state.singleCPSelection.projectId)
    }

    updateRows() {
        this.taskRowsTableContent.updateRows()
    }

    updateRow(id) {
        this.taskRowsTableContent.updateRow(id)
    }

    _updateView(tasksCount) {
        this._updateTaskSelectionView()
        this.$el.toggleClass("allTasksLoaded", TaskManagementStore.isAllTasksLoaded())
        this._updateNoTasksMessage(tasksCount === 0)
        this.taskTableContentVerticalScrollWrapper.refreshScroll()
        PageOverlayTipsManager.getInstance().refreshDynamicTips()
    }

    _updateNoTasksMessage(taskRowsEmpty) {
        const taskNameFilterEmpty = !TaskManagementStore.getTaskNameFilter()
        this.$el.toggleClass("noTasks", taskRowsEmpty && taskNameFilterEmpty)
        this.$el.toggleClass("noTasksFound", taskRowsEmpty && !taskNameFilterEmpty)
        this.find('.tasksTablesWrapper').toggle(!taskRowsEmpty)
    }

    show() {
        super.show()
        this.taskTableContentHorizontalScrollWrapper.show()
    }
}

export default connect(
    (state) => ({
        sorting: getTasksSorting(state),
        archivedProjectIds: getArchivedProjectIds(state),
        viewerSettings: getViewerSettings(state),
        manageableTaskIds: getManageableTaskIds(state),
        editableProjectIds: getEditableProjectIds(state),
        showSelection: isNeedToShowSelection(state),
        singleCPSelection: getSingleCPSelection(state),
        selectedTaskIds: getSelectedTaskIds(state),
        bulkOperationsPanelShown: isBulkOperationsPanelShown(state),
        columnsWithOrder: getShownColumnsWithOrder(state),
        isCPPanelClosed: isCPPanelClosed(state),
        scrollToTopButtonShifted: showSupportQuestionButton(state),
    }),
    (dispatch) => ({
        changeTasksSortingAction: bindActionCreators(changeTasksSortingAction, dispatch),
        updateTaskTypeOfWork: bindActionCreators(updateTaskTypeOfWork, dispatch),
    })
)(TasksTable)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/TasksTable.js